var exports = {
  "kL": "xa15a2ab7--7a573d--container",
  "kA": "xa15a2ab7--7a573d--logo-block",
  "DD": "xa15a2ab7--7a573d--title",
  "VG": "xa15a2ab7--7a573d--title-block",
};

module.exports = exports;
